<template>
  <div class="model-bullet" ref='bulletBox'>
    <canvas class="bullet-canvas" ref="bulletCanvas">
      <!-- 您的浏览器不支持canvas
      {{isPlay}}{{textList}} -->
    </canvas>
  </div>
</template>
<script>
  import {
    Barrage
  } from '@/components/modeldemo/Barrage'
  import {
    getPlatform
  } from '@/components/modeldemo/Utils'
  import {
    dateFormat
  } from '@/utils/dateUtil.js'

  let _barrageInstance = null,
    _isMobile = false,
    _rect = {},
    _cacheBulletList = [],
    _bulletOption= {
      total:0,
      curBulletsOffsetIdx:0,
    },
    _bulletHttp = null
    //本地js拿5条弹幕shoot进弹幕实例
  const _shootSomeFromLocal = () => {
    const shootBulletsOffset = 5
    const curShootBullets = _cacheBulletList.filter((item,idx)=> (idx >= _bulletOption.curBulletsOffsetIdx && idx < _bulletOption.curBulletsOffsetIdx + shootBulletsOffset))
    curShootBullets.forEach((bulletItem, idx) => {
      if (idx !== 0) {
        _barrageInstance.shoot({
          bulletPkId: bulletItem.bulletPkId,
          value: bulletItem.bulletContent,
          speed: _isMobile ? parseInt((Math.random() * 2) + 2) : parseInt((Math.random() * 3) + 3),
          offsetLeft: parseInt((Math.random() * _rect.width) + 1),
          avatarUrl: bulletItem.bulletAvatarUrl
        })
      } else {
        _barrageInstance.shoot({
          bulletPkId: bulletItem.bulletPkId,
          value: bulletItem.bulletContent,
          speed: _isMobile ? parseInt((Math.random() * 2) + 2) : parseInt((Math.random() * 3) + 3),
          avatarUrl: bulletItem.bulletAvatarUrl
        })
      }
    })
    _bulletOption.curBulletsOffsetIdx += curShootBullets.length
    if(_bulletOption.curBulletsOffsetIdx >= _cacheBulletList.length -1) _bulletOption.curBulletsOffsetIdx = 0
    // console.log('此时的本地信息是?',_bulletOption.total,_bulletOption.curBulletsOffsetIdx,_cacheBulletList.length);
    // console.log(_barrageInstance)
  }

  export default {
    props: {
      isPlay: {
        type: Boolean,
        default: false
      }
    },
    watch: {
      isPlay: function (newValue) {
        if (_barrageInstance) {
          _barrageInstance.allowPlay(newValue)
          _barrageInstance.draw()
        }
      }
    },
    mounted() {
      _rect = this.$refs.bulletBox.getBoundingClientRect()
      this.$refs.bulletCanvas.width = _rect.width
      this.$refs.bulletCanvas.height = _rect.height
      _isMobile = getPlatform().platform === 'mobile' ? true : false
      _barrageInstance = Barrage.init(this.$refs.bulletCanvas)
      //初始弹幕获取成功并存入js缓存后,从js缓存将弹幕shoot进弹幕实例
      this.getBullets({
        offset: 0,
        limit: 10
      }).then(()=>{
        _shootSomeFromLocal()
      })
      //弹幕实例的弹幕存量不足时,调用此回调
      _barrageInstance.listenBarrageListAlmostEmpty(() => {
        // console.log('你被调用了吗')
        _shootSomeFromLocal()
        //若已缓存的弹幕数量比远程的少,且此时没有正在pendding的getBullets请求,就顺便发个请求缓存更多弹幕
        if(_cacheBulletList.length < _bulletOption.total && !_bulletHttp){
          this.getBullets({offset:_cacheBulletList.length})
        }
        //只有返回一个非pending的promise,弹幕实例才能再次触发此回调函数
        return Promise.resolve()
      })
      // await this.getBullets({offset:20,limit:10})
      _shootSomeFromLocal()
    },
    methods: {
      shootOne(bulletContext) {
        const wxUserInfo = JSON.parse(window.sessionStorage.getItem('wxUserInfo'))
        if (!wxUserInfo.openid || !wxUserInfo.avatarInBE) {
          this.$Message.warnig('微信授权异常')
          return Promise.reject()
        }
        const data = {
          bulletContent: bulletContext,
          bulletModelId: this.$route.query.id,
          bulletUser: wxUserInfo.openid,
          bulletAvatarUrl: wxUserInfo.headimgurlBE
        }
        return this.$http('/api/bullet/bullet', data, 'POST').then(res => {
          if (res.data.status === 200) {
            _barrageInstance.shoot({
              bulletPkId:-1,
              value: bulletContext,
              speed: _isMobile ? parseInt((Math.random() * 2) + 2) : parseInt((Math.random() * 3) + 3),
              avatarUrl: wxUserInfo.headimgurlBE
            })
            _bulletOption.total++
            if (this.$props.isPlay && !_barrageInstance.isPlay) {
              _barrageInstance.allowPlay(true)
              _barrageInstance.draw()
            }
          } else {
            // this.$Message.error('弹幕发送失败')
          }
        }).catch(() => {
          // this.$Message.error('弹幕发送异常')
        })
      },
      getBullets({
        offset,
        limit = 10
      }) {
        if(_bulletHttp) return _bulletHttp
        _bulletHttp = this.$http('/api/bullet/pageParam', {
          offset,
          limit,
          modelId:this.$route.query.id
        }).then(res => {
          if (res.data.status === 200) {
            _cacheBulletList = _cacheBulletList.concat(res.data.data.records.map(item=>({
              bulletPkId:item.bulletPkId,
              bulletContent:item.bulletContent,
              bulletAvatarUrl:item.bulletAvatarUrl
            })))
            _bulletOption.total = res.data.data.total
          }else{
            // console.log('弹幕获取失败');
          }
          _bulletHttp = null
        }).catch(()=>{
          // console.log('弹幕获取异常');
          _bulletHttp = null
        }).finally(()=>{
          _bulletHttp = null
        })
        return _bulletHttp
      }
    },
    beforeDestroy() {
      if (_barrageInstance) {
        _barrageInstance.allowPlay(false)
      }
    },
  }

</script>
<style scoped>
  .model-bullet {
    pointer-events: none;
    background-color: transparent;
  }

  .bullet-canvas {
    position: relative;
    pointer-events: none;
    background-color: transparent;
    z-index: 10000;
  }

</style>
